var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftGold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#gift-gold_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  x: 1,
  fill: "url(#gift-gold_svg__b)",
  rx: 13
}), /*#__PURE__*/React.createElement("path", {
  fill: "#161639",
  d: "M21.563 8.188h-3.008A2.75 2.75 0 0 0 14.49 4.5a2.5 2.5 0 0 0-.49.705 2.5 2.5 0 0 0-.49-.705 2.75 2.75 0 0 0-4.065 3.687H6.437a1.375 1.375 0 0 0-1.375 1.375v2.75a1.375 1.375 0 0 0 1.375 1.375v5.5a1.375 1.375 0 0 0 1.375 1.375h12.375a1.375 1.375 0 0 0 1.375-1.375v-5.5a1.375 1.375 0 0 0 1.375-1.375v-2.75a1.375 1.375 0 0 0-1.375-1.375M15.46 5.472a1.375 1.375 0 1 1 1.942 1.942c-.421.43-1.65.662-2.69.748.086-1.04.318-2.269.748-2.69m-4.864 0a1.383 1.383 0 0 1 1.942 0c.43.421.662 1.65.748 2.69-1.04-.086-2.269-.318-2.69-.748a1.384 1.384 0 0 1 0-1.942m10.966 6.84h-6.875V18.5a.687.687 0 1 1-1.376 0v-6.187H6.439v-2.75h6.875v2.75h1.374v-2.75h6.876z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "gift-gold_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 26 -12.8908 0 13.89 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE600"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCA31E"
})), /*#__PURE__*/React.createElement("filter", {
  id: "gift-gold_svg__a",
  width: 74,
  height: 74,
  x: -23,
  y: -24,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_8905_33612"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0156863 0 0 0 0 0.054902 0 0 0 0 0.164706 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_backgroundBlur_8905_33612",
  result: "effect2_dropShadow_8905_33612"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_8905_33612",
  result: "shape"
})))));
export default SvgGiftGold;